var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccentEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2021_263)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 32,
    fill: "#E8D8FD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 30,
    r: 32,
    fill: "#F7F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4997 9.5C15.0997 9.5 14.3331 6.16667 14.4997 4.5L3.99972 11L-2.50024 25.5C-3.00024 29.6667 -2.50033 39.5 -0.500335 39.5C1.49967 39.5 3.16642 38 3.49976 37.5L4.49979 34C4.49979 31.6 6.16646 31 6.99979 31H9.49979C11.8998 31 12.4998 32.6667 12.4998 33.5V41.5C12.8331 42.3333 14.1997 45 16.9997 45C19.7997 45 21.1665 42.3333 21.4998 41.5V30C21.4998 28.4 23.1665 28 23.9998 28H27.4998C29.8998 28 30.4998 26 30.4998 25C30.4998 22.6 28.4998 22 27.4998 22C24.2998 22 24.1665 20 24.4998 19C24.4998 16.6 26.4998 16.3333 27.4998 16.5H31.4998C34.6998 16.5 35.1665 14.1667 34.9998 13C34.5998 10.2 32.4998 9.5 31.4998 9.5H19.4997Z",
    fill: "#D2B1FC",
    stroke: "#D2B1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 32H65L63 45.5L57 55L48.5 61C46.8333 62.5 43.5 62.4 43.5 60C43.5 57.6 40.8333 57 39.5 57C38.8333 56.8333 37.5 56 37.5 54C37.5 52 39.1667 51.5 40 51.5H43.5C44.1667 51.1667 45.5 50 45.5 48C45.5 46 44.1667 44.8333 43.5 44.5H38.5C37.3333 44.6667 35 44 35 40C35 36 37.3333 35 38.5 35H45.5C47.9 35 48.5 33.3333 48.5 32.5V29C48.5 26.6 50.5 26 51.5 26H52.5C53.3333 26.1667 55 27 55 29C55 31 57 31.8333 58 32Z",
    fill: "#D2B1FC",
    stroke: "#D2B1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 11H13.5C12.9696 11 12.4609 11.2107 12.0858 11.5858C11.7107 11.9609 11.5 12.4696 11.5 13V31L15.5 27H29.5C30.0304 27 30.5391 26.7893 30.9142 26.4142C31.2893 26.0391 31.5 25.5304 31.5 25V13C31.5 12.4696 31.2893 11.9609 30.9142 11.5858C30.5391 11.2107 30.0304 11 29.5 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7671 23L20.4634 15.2227H22.5366L25.2222 23H23.4927L22.9072 21.2061H20.0928L19.5073 23H17.7671ZM22.499 19.9492L21.5269 16.9736H21.4731L20.501 19.9492H22.499Z",
    fill: "#913FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 32H52.5C53.0304 32 53.5391 32.2107 53.9142 32.5858C54.2893 32.9609 54.5 33.4696 54.5 34V52L50.5 48H36.5C35.9696 48 35.4609 47.7893 35.0858 47.4142C34.7107 47.0391 34.5 46.5304 34.5 46V34C34.5 33.4696 34.7107 32.9609 35.0858 32.5858C35.4609 32.2107 35.9696 32 36.5 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.057 38.393L47.461 38.798C46.327 42.002 44.194 43.91 40.999 44.891C40.846 44.558 40.432 43.928 40.171 43.613C43.231 42.848 45.157 41.237 46.057 38.393ZM42.925 38.474C43.798 41.021 45.697 42.857 48.874 43.55C48.559 43.856 48.127 44.486 47.929 44.864C44.536 43.982 42.754 41.966 41.611 38.87L42.925 38.474ZM40.369 37.673H48.676V38.951H40.369V37.673ZM43.825 36.305H45.175V38.456H43.825V36.305Z",
    fill: "#913FF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2021_263"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccentEarth);
export default __webpack_public_path__ + "static/media/iconAccentEarth.d7ce9bd01c9b084d61b8b516fe229f79.svg";
export { ForwardRef as ReactComponent };